import React, { useContext, useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useRouter } from 'next/router';

// store
import { GlobalContext } from '/context';

// actions
import { getMenus } from '/context/actions/menu';

// components
import Header from '/components/layouts/Header';
import NavBar from '/components/layouts/NavBar';
import Footer from '/components/layouts/Footer';
import useWindowSize from '/utils/useWindowSize';

const useStyles = makeStyles(() => ({
    root: (props) => {
        return {
            width: props.windowsize > 700 ? '100%' : '100vh',
            height: '100%',
            background: '#F3F3F3',
        };
    },
    bgImage: {
        backgroundImage: 'url("/slider/1.jpeg") !important', // Зургийн зам
        backgroundSize: '100%  !important', // Контейнерт багтаахs
        // backgroundPosition: 'center !important', // Голд нь байрлуулах
        backgroundRepeat: 'no-repeat !important', // Давтагдахгүй
        width: '100%',
    },
}));

export default function HomeLayout({ children }) {
    const { width } = useWindowSize();
    const router = useRouter();

    const { state, dispatch } = useContext(GlobalContext);
    const [isMobileNavOpen, setMobileNavOpen] = useState(false);
    const classes = useStyles({ windowsize: width });
    const [imageMore, setImageMore] = useState(false);

    useEffect(() => {
        getMenus(dispatch);
        if (router.pathname.includes('structures')) {
            // console.log('structures  байна!');
            setImageMore(true);
        } else setImageMore(true);
    }, []);


    useEffect(() => {
        if (!router.isReady) return; // Router бүрэн ачаалсны дараа үргэлжлүүлнэ
        if (router.pathname.includes('structures')) {
            setImageMore(true);
        } else {
            setImageMore(false);
        }
    }, [router.isReady, router.pathname]);

    const navbarMenuClose = () => {
        setMobileNavOpen(false);
    };

    return (
        <div>
            <main>
                <Box className={imageMore ? `${classes.root} ${classes.bgImage}` : classes.root}>
                    <Header
                        onMobileNavOpen={() => setMobileNavOpen(true)}
                        menus={state.menu.list}
                    />
                    {isMobileNavOpen ? (
                        <NavBar
                            onMobileClose={navbarMenuClose}
                            openMobile={isMobileNavOpen}
                            onClose={navbarMenuClose}
                        />
                    ) : (
                        ''
                    )}
                    {children}
                    <Footer />
                </Box>
            </main>
        </div>
    );
}
